import React from "react"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import * as actionCreators from "../redux/action_creators"
import { alerts } from "../util/alert_error_utils"
import { makeToast } from "../util/toast_util"
import OnboardingSection from "../components/onboarding/onboarding_section"
import { appStrings } from "../common/strings/app_strings"
import { appConsts } from "../common/constants/app_consts"
import { SettingsFormField } from "../components/settings/settings_form_field"
import { checkIfEmailIsValid } from "../util/onboarding_utils"

const getParams = param => {
    return new URL(document.location).searchParams.get(param)
}

const emailFromSearch = search => {
    const parseEmail = search.split("email=")
    const em = parseEmail[1] ? parseEmail[1] : ""
    const parsed = em.split("&")
    return parsed[0]
}

const {
    onboarding: {
        signUpTitle,
        signUpButton,
        email,
        alreadyHaveAccount,
        signIn,
    },
} = appStrings
const { regExEmailValidation } = appConsts
class SignUp extends React.Component {
    constructor(props) {
        super(props)
        const email = emailFromSearch(props.location.search)
        const tier = getParams("tier") || ""
        const cycle = getParams("cycle") || ""

        this.state = {
            email: email || "",
            showComponent: false,
            tier,
            cycle,
        }
        this.textInput = null
        this.setTextInputRef = element => (this.textInput = element)
        this.focusTextInput = () => {
            if (this.textInput) this.textInput.focus()
        }
    }

    componentWillMount() {
        const { email } = this.state
        if (email) {
            this.submitEmail()
            // wait for email to submit before showing component
            setTimeout(() => {
                this.setState({ showComponent: true })
            }, 400)
        } else {
            this.setState({ showComponent: true })
        }
    }

    submitEmail = () => {
        const { email, tier, cycle } = this.state
        const { signUp, history } = this.props
        const isValid = checkIfEmailIsValid(email, regExEmailValidation)

        if (!isValid || email.length === 0) {
            const { msg } = alerts["validEmailRequired"]
            makeToast(msg, "danger")
            this.focusTextInput()
            return
        }

        signUp({ email, tier, cycle }, history)
    }

    onChange = (value, key) => this.setState({ [key]: value })

    render() {
        return this.state.showComponent ? (
            <div>
                <OnboardingSection
                    sectionTitle={signUpTitle}
                    buttonValue={signUpButton}
                    onClickAction={this.submitEmail}
                    hasSkipButton={false}
                    isWide={false}
                >
                    <div className="col-md-12 form-group">
                        <SettingsFormField
                            id="email"
                            value={this.state.email}
                            onChangeAction={this.onChange}
                            tabIndex="3"
                            required={true}
                            focus={true}
                            placeholder={email}
                            setRef={this.setTextInputRef}
                        />
                    </div>
                </OnboardingSection>
                <div className="center">
                    {alreadyHaveAccount} &nbsp;
                    <Link to="/signIn">{signIn}</Link>
                </div>
                <Link id="sign-up-link" to="/signIn">
                    <button className="btn btn-primary sign-in-button">Sign in</button>
                </Link>
            </div>
        ) : (
            <div />
        )
    }
}

function mapStateToProps(state) {
    return state
}
export default connect(
    mapStateToProps,
    actionCreators,
)(SignUp)



// WEBPACK FOOTER //
// ./src/pages/sign_up.jsx